/* GT storefront behaviour. One file, no dependencies. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var focusables = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Drawers (cart, mobile menu) ---------- */
  var activeDrawer = null, lastTrigger = null;
  function openDrawer(name, trigger) {
    var el = $('[data-gt-drawer="' + name + '"]');
    if (!el) return;
    clearTimeout(el._gtT);
    if (activeDrawer && activeDrawer !== el) closeDrawer(false);
    lastTrigger = trigger || doc.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { if (activeDrawer === el) el.classList.add('is-open'); });
    root.classList.add('gt-locked');
    activeDrawer = el;
    $$('[data-gt-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('[data-gt-autofocus]', el) || $(focusables, el);
    if (f) f.focus();
  }
  function closeDrawer(restore) {
    if (!activeDrawer) return;
    var el = activeDrawer, name = el.getAttribute('data-gt-drawer');
    el.classList.remove('is-open');
    root.classList.remove('gt-locked');
    $$('[data-gt-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    el._gtT = setTimeout(function () { el.hidden = true; }, 250);
    activeDrawer = null;
    if (restore !== false && lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  doc.addEventListener('click', function (e) {
    var o = e.target.closest('[data-gt-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-gt-open'), o); return; }
    if (e.target.closest('[data-gt-close]')) { e.preventDefault(); closeDrawer(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activeDrawer) { closeDrawer(); return; }
      closeAllDropdowns(true);
    }
    if (e.key === 'Tab' && activeDrawer) {
      var items = $$(focusables, activeDrawer).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Dropdowns + mega menu ---------- */
  function setDropdown(btn, open) {
    var panel = doc.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    clearTimeout(panel._gtT);
    if (open) { panel.classList.remove('is-closing'); panel.hidden = false; return; }
    if (panel.hidden) return;
    if (reduce) { panel.hidden = true; return; }
    /* M05: fade + rise out over 150 ms, then hide */
    panel.classList.add('is-closing');
    panel._gtT = setTimeout(function () { panel.hidden = true; panel.classList.remove('is-closing'); }, 150);
  }
  function closeAllDropdowns(restore) {
    $$('[data-gt-dd][aria-expanded="true"]').forEach(function (b) { setDropdown(b, false); if (restore) b.focus(); });
  }
  $$('[data-gt-dd]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = btn.getAttribute('aria-expanded') !== 'true';
      closeAllDropdowns(false);
      setDropdown(btn, open);
    });
    var item = btn.closest('[data-gt-dd-item]');
    if (item && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      item.addEventListener('mouseenter', function () { clearTimeout(item._gtL); closeAllDropdowns(false); setDropdown(btn, true); });
      item.addEventListener('mouseleave', function () { item._gtL = setTimeout(function () { setDropdown(btn, false); }, 100); });
    }
  });
  doc.addEventListener('click', function (e) {
    if (!e.target.closest('[data-gt-dd-item]')) closeAllDropdowns(false);
  });

  /* ---------- Cart (AJAX + section rendering) ---------- */
  var cartSection = 'gt-cart-drawer';
  var CHECK = '<svg class="gt-icon gt-icon--sm" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><polyline points="20 6 9 17 4 12"/></svg>';
  function renderCart(sections) {
    if (!sections || !sections[cartSection]) return;
    var tmp = doc.createElement('div');
    tmp.innerHTML = sections[cartSection];
    var fresh = $('[data-gt-drawer-inner]', tmp), current = $('[data-gt-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
    var count = fresh ? fresh.getAttribute('data-gt-count') : null;
    if (count !== null) $$('[data-gt-cart-count]').forEach(function (n) { n.textContent = count; });
  }
  function cartRequest(url, body) {
    body.sections = cartSection;
    body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  /* Capture phase on purpose. Shopify's web pixels script puts its own submit listener on every form whose action contains /cart/add and counts an add
     unless the event is already defaultPrevented. A bubbling listener on document runs after it, so one click was counted twice: once by that form
     listener and once by the /cart/add.js fetch below. Cancelling the submit in the capture phase leaves the fetch as the single count. Keep the true. */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-gt-atc]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-gt-atc-msg]');
    /* M06: Adding... then Added with a check for 1.4 s; on error the button shakes and an inline message shows. Feedback goes on the button that was pressed (main or sticky bar) */
    if (form._gtBusy) return;
    form._gtBusy = true;
    if (btn) {
      if (btn._gtT) { clearTimeout(btn._gtT); btn._gtT = 0; } else { btn._gtLabel = btn.innerHTML; }
      btn.setAttribute('aria-busy', 'true');
      btn.classList.remove('gt-shake');
      btn.textContent = 'Adding…';
    }
    cartRequest('/cart/add.js', { items: [{ id: Number(id.value), quantity: qty ? Number(qty.value) : 1 }] })
      .then(function (res) {
        if (msg) msg.textContent = '';
        if (btn) { btn.innerHTML = CHECK + '<span>Added</span>'; btn._gtT = setTimeout(function () { btn.innerHTML = btn._gtLabel; btn._gtT = 0; }, 1400); }
        var land = function () { renderCart(res.sections); openDrawer('cart', btn); };
        /* Phase 4 M13: on the PDP the sachet flies into the cart first (gt-pdp-motion.js), then the count and the drawer update */
        if (window.gtPdp && !reduce && form.hasAttribute('data-gt-fly')) { form.dispatchEvent(new CustomEvent('gt:added', { bubbles: true, detail: { button: btn } })); setTimeout(land, 560); }
        else land();
      })
      .catch(function () {
        if (msg) msg.textContent = "Couldn't add that. Try again.";
        if (btn) { btn.innerHTML = btn._gtLabel; void btn.offsetWidth; btn.classList.add('gt-shake'); }
      })
      .finally(function () { form._gtBusy = false; if (btn) btn.removeAttribute('aria-busy'); });
  }, true);
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gt-qty]');
    if (!b) return;
    e.preventDefault();
    cartRequest('/cart/change.js', { id: b.getAttribute('data-key'), quantity: Number(b.getAttribute('data-gt-qty')) })
      .then(function (res) { renderCart(res.sections); var f = $('[data-gt-drawer="cart"] [data-gt-autofocus]'); if (f) f.focus(); })
      .catch(function () {});
  });

  /* ---------- Accordions: M05 close moment (body fades up, then the row closes) ---------- */
  $$('.gt-acc details > summary').forEach(function (sum) {
    var d = sum.parentNode;
    sum.addEventListener('click', function (e) {
      if (!d.open || reduce) return;
      e.preventDefault();
      if (d._gtT) { clearTimeout(d._gtT); d._gtT = 0; d.classList.remove('is-closing'); return; }
      d.classList.add('is-closing');
      d._gtT = setTimeout(function () { d._gtT = 0; d.open = false; d.classList.remove('is-closing'); }, 200);
    });
  });

  /* ---------- Accordions: one open per group ---------- */
  $$('[data-gt-acc-group]').forEach(function (group) {
    $$('details', group).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        $$('details', group).forEach(function (o) { if (o !== d && o.closest('[data-gt-acc-group]') === group) o.open = false; });
      });
    });
  });

  /* ---------- Milk / Sorbet toggle ---------- */
  $$('[data-gt-base-toggle] [data-value]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.setAttribute('data-gt-base', b.getAttribute('data-value'));
      $$('[data-gt-base-toggle] [data-value]').forEach(function (o) { o.setAttribute('aria-pressed', o.getAttribute('data-value') === b.getAttribute('data-value') ? 'true' : 'false'); });
    });
  });

  /* ---------- Collection filter chips ---------- */
  $$('[data-gt-filter]').forEach(function (bar) {
    var scope = bar.closest('[data-gt-filter-scope]') || doc;
    $$('[data-filter]', bar).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        $$('[data-filter]', bar).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        $$('[data-gt-base]', scope).forEach(function (card) {
          var b = card.getAttribute('data-gt-base');
          card.hidden = !(f === 'all' || f === b);
        });
        $$('[data-gt-filter-group]', scope).forEach(function (g) {
          g.hidden = !$$('[data-gt-base]', g).some(function (c) { return !c.hidden; });
        });
      });
    });
  });

  /* ---------- Carousel dots (mobile gallery) ---------- */
  $$('[data-gt-carousel]').forEach(function (track) {
    var dots = $$('[data-gt-dot]', track.parentNode);
    var slides = $$('[data-gt-slide]', track);
    if (!dots.length) return;
    function setActive() {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(setActive); }, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { if (slides[n]) track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); });
    setActive();
  });

  /* ---------- Mobile sticky add-to-cart bar ---------- */
  var anchor = $('[data-gt-atc-anchor]'), bar = $('[data-gt-sticky-bar]');
  if (anchor && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* Phase 4 R2: shows whenever the main add to cart is off screen (above, or below while the PDP story plays) */
        var show = !en.isIntersecting;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('a, button', bar).forEach(function (n) { n.tabIndex = show ? 0 : -1; });
      });
    }).observe(anchor);
  }

  /* ---------- Build your own 6-pack (client-side only, Phase 1) ---------- */
  $$('[data-gt-byo]').forEach(function (byo) {
    var MAX = 6, picks = [], shiftFrom = -1, pending = null;
    var items = $$('[data-gt-byo-item]', byo);
    var slots = $$('[data-gt-tray-slot]', byo);
    var minis = $$('[data-gt-mini-slot]', byo);
    var countEls = $$('[data-gt-byo-count]', byo);
    var buttons = $$('[data-gt-byo-submit]', byo);
    var note = $('[data-gt-byo-note]', byo);
    var live = $('[data-gt-byo-live]', byo);
    function countOf(key) { return picks.filter(function (k) { return k === key; }).length; }
    function render() {
      var n = picks.length;
      items.forEach(function (it) {
        var key = it.getAttribute('data-key'), c = countOf(key);
        $('[data-gt-byo-n]', it).textContent = c;
        $('[data-gt-byo-minus]', it).disabled = c === 0;
        $('[data-gt-byo-plus]', it).disabled = n >= MAX;
      });
      /* M07: only slots whose flavour changed are redrawn, so existing sachets don't drop again */
      slots.forEach(function (s, i) {
        var key = picks[i] || '';
        if ((s.getAttribute('data-k') || '') === key) return;
        s.setAttribute('data-k', key);
        s.innerHTML = '';
        s.classList.toggle('is-filled', !!key);
        if (key) {
          var t = $('template[data-gt-slot-tpl="' + key + '"]', byo);
          if (t) { var c = t.content.cloneNode(true); if (shiftFrom > -1 && i >= shiftFrom && c.firstElementChild) c.firstElementChild.classList.add('gt-shift'); s.appendChild(c); }
        }
      });
      minis.forEach(function (m, i) {
        var key = picks[i];
        m.className = 'gt-byo-bar__slot' + (key ? ' is-filled gt-f--' + key : '');
      });
      countEls.forEach(function (c) { c.textContent = n + ' of 6'; });
      buttons.forEach(function (b) {
        if (n < MAX) { b.textContent = 'Pick ' + (MAX - n) + ' more'; b.setAttribute('aria-disabled', 'true'); b.classList.add('gt-btn--disabled'); }
        else { b.textContent = 'Add to cart'; b.setAttribute('aria-disabled', 'false'); b.classList.remove('gt-btn--disabled'); }
      });
      if (note && n < MAX) note.hidden = true;
      if (live) live.textContent = n + ' of 6 picked';
    }
    items.forEach(function (it) {
      var key = it.getAttribute('data-key');
      $('[data-gt-byo-plus]', it).addEventListener('click', function () { flush(); if (picks.length < MAX) { picks.push(key); render(); } });
      $('[data-gt-byo-minus]', it).addEventListener('click', function () { flush(); var i = picks.lastIndexOf(key); if (i > -1) remove(i); });
    });
    /* M07: the last-added slot of that flavour lifts out (180 ms), later sachets shuffle back into order (FLIP, 240 ms) */
    function remove(i) {
      var child = slots[i] && slots[i].firstElementChild;
      if (reduce || !child) { picks.splice(i, 1); render(); return; }
      var rects = slots.map(function (s) { return s.firstElementChild ? s.firstElementChild.getBoundingClientRect() : null; });
      child.classList.add('gt-lift');
      pending = function () {
        pending = null;
        picks.splice(i, 1);
        shiftFrom = i; render(); shiftFrom = -1;
        for (var j = i; j < picks.length; j++) {
          var c = slots[j].firstElementChild, old = rects[j + 1];
          if (!c || !old) continue;
          var nr = c.getBoundingClientRect();
          c.style.transform = 'translate(' + (old.left - nr.left) + 'px,' + (old.top - nr.top) + 'px)';
          void c.offsetWidth;
          c.style.transition = 'transform 240ms var(--gt-ease-out)';
          c.style.transform = '';
        }
      };
      pending._t = setTimeout(pending, 180);
    }
    function flush() { if (pending) { clearTimeout(pending._t); pending(); } }
    buttons.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (picks.length === MAX && note) { note.hidden = false; }
      });
    });
    render();
  });
})();
